export default "__VITE_ASSET__35dfdea0__"